import Vue from 'vue';
import Vue2Filters from 'vue2-filters';
import moment from 'moment';
import { cn } from './utils/classnames';
import { formatCompactNumber } from './utils/formatters';

Vue.mixin({
	methods: {
		cn,
		hideModal() {
			this.$modal.hide(this.$parent.name);
		},

		formatCompactNumber(value, precision = 1) {
			return formatCompactNumber(value, precision);
		},

		formatCurrency(value, precision = 0, currency = null, locale = null, nullOnEmpty = false) {
			currency = currency != null ? currency : localStorage.getItem('reopt_baseCurrency') || 'USD';
			locale = locale != null ? locale : localStorage.getItem('reopt_locale') || 'en-US';

			if (value == null || value == "") {
				if (nullOnEmpty) {
					return null;
				} else {
					value = 0;
				}
			}

			var raw = value.toString().replace(/[^\d.-]/g, '') / 100;

			const formatter = new Intl.NumberFormat(locale, {
				style: 'currency',
				currency: currency,
				minimumFractionDigits: precision,
				maximumFractionDigits: precision,
			});

			return formatter.format(raw);
		},

		convertCurrency(value, precision, locale, from, to, nullOnEmpty = false) {
			to = to != null ? to : localStorage.getItem('reopt_baseCurrency') || 'USD';
			locale = locale != null ? locale : localStorage.getItem('reopt_locale') || 'en-US';

			if (value == null || value == "") {
				if (nullOnEmpty) {
					return null;
				} else {
					value = 0;
				}
			}

			this.newValue = parseFloat(value.toString().replace(/[^\d.-]/g, '') / 100);
			console.log(from, to, this.newValue);
			if (from != to) {
				axios.post('/api/get-exchange-rate', {
					from: from,
					to: to
				}).then(response => {
					let exchangeRate = response.data;
					console.log(this.newValue, this.newValue * exchangeRate)
					this.newValue = this.newValue * exchangeRate;
				}).catch(error => {
					console.log(error);
				});
			}

			const formatter = new Intl.NumberFormat(locale, {
				style: 'currency',
				currency: to,
				minimumFractionDigits: precision,
				maximumFractionDigits: precision,
			});

			return formatter.format(this.newValue);
		},

		prepCurrency(value) {
			return (value == null || value == "") ? null : value.replace(/[^\d.-]/g, '') * 100;
		},

		formatNumber(value) {
			return value == null ? null : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

		formatDate(value, format = 'MM/DD/YYYY') {
			return value == null ? null : moment(value).format(format);
		},

		highlightSubmenu(isVisible, element) {
			document.querySelectorAll('.sidebar .sub-menu a').forEach(el => el.classList.remove('active'));

			if (isVisible) {
				let link = element.target.querySelector('a');

				if (link) {
					let name = link.getAttribute('name');
					let match = document.querySelector(`.sidebar .sub-menu a[href$='${name}']`);
					if (match) {
						match.classList.add('active');
					}
				}
			}
		}
	}
});

Vue.mixin(Vue2Filters.mixin);

export default {}